import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  Grid,
  makeStyles,
  IconButton
} from '@material-ui/core';
import {
  DeleteOutline as DeleteIcon
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(3,0,3,0)
  },
  imageWrapper: {
    width: '167px'
  },
  imageArea: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
    width: '100%',
    paddingBottom: '100%',
    position: 'relative',
    marginBottom: theme.spacing(2),

    '& img': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  }
}));

const ImageList = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  let { images, disabled } = props;

  if(!Array.isArray(images)) {
    images = [];
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        {images.map(image =>
          <Grid item key={image.id}>
            <div className={classes.imageWrapper}>
              <div className={classes.imageArea}>
                <img src={image.thumbnail} alt="" />
              </div>
              <Grid container wrap="nowrap">
                <Grid item xs style={{wordBreak: 'break-word'}}>
                  {image.name}
                </Grid>
                <Grid item>
                  <IconButton aria-label={t('common:remove')} title={t('common:remove')} onClick={() => props.onDelete(image.id)} color="primary" size="small" disabled={disabled}>
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

ImageList.propTypes = {
  images: PropTypes.array,
  onDelete: PropTypes.func,
  disabled: PropTypes.bool
};

export default ImageList;
